import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white">
      {/* Header */}
      <header className="bg-black/80 backdrop-blur-md border-b border-gray-700">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_pdf-to-site-6/artifacts/jfbpb7og_Solutions%20Logo%20%282%29.png" 
              alt="Ability Healthcare Solutions" 
              className="h-12 w-auto"
              style={{ mixBlendMode: 'screen' }}
            />
            <div className="text-left">
              <div className="text-sm uppercase tracking-wider text-gray-300 font-bold">Turning Challenges</div>
              <div className="text-sm uppercase tracking-wider text-blue-400 font-bold">Into Solutions</div>
            </div>
          </Link>
          <Link
            to="/"
            className="text-blue-400 hover:text-blue-300 font-medium transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8">Terms and Conditions</h1>
        
        <div className="prose prose-invert prose-lg max-w-none space-y-6">
          <p className="text-gray-300">
            Welcome to Ability Healthcare Solutions!
          </p>
          <p className="text-gray-300">
            These terms and conditions outline the rules and regulations for the use of Ability Healthcare Solutions' website and services. By accessing this website and purchasing services, you accept these terms and conditions. Do not continue to use Ability Healthcare Solutions if you do not agree to all of the terms and conditions stated on this page.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">IMPORTANT: Payment and Refund Policy</h2>
          <p className="text-white font-semibold mb-2">
            ALL PAYMENTS ARE FINAL AND NON-REFUNDABLE.
          </p>
          <p className="text-gray-300">
            By purchasing any service from Ability Healthcare Solutions, you acknowledge and agree that:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4 mt-2">
            <li>All payments are <strong>100% non-refundable</strong> under any circumstances</li>
            <li><strong>No rescheduling is permitted</strong> after booking confirmation</li>
            <li>Failure to attend your scheduled session will result in <strong>forfeiture of payment</strong></li>
            <li>No credits, exchanges, or transfers will be issued</li>
            <li>This policy applies to all services including free discovery calls, consultations, and digital products</li>
          </ul>
          <p className="text-gray-300 mt-4">
            Please carefully consider your schedule and commitment before making any purchase. By completing payment, you confirm that you understand and accept this strict no-refund, no-reschedule policy.
          </p>
          <p className="text-gray-300 mt-4 font-semibold">
            Note: Only payment terms outside of what's listed must be in contract form signed by client and provider.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Service Descriptions and Booking</h2>
          <p className="text-gray-300">
            Ability Healthcare Solutions offers various consulting services for home care agency development. Service descriptions, prices, and durations are provided on our website. By booking a service, you commit to attending at the scheduled time and understand that the terms outlined in the Payment and Refund Policy apply.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">License and Intellectual Property</h2>
          <p className="text-gray-300">
            Unless otherwise stated, Ability Healthcare Solutions and/or its licensors own the intellectual property rights for all material on this website and in provided services. All intellectual property rights are reserved.
          </p>
          <p className="text-gray-300">You must not:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li>Republish, sell, or redistribute content from Ability Healthcare Solutions</li>
            <li>Reproduce, duplicate, or copy materials provided during consultations</li>
            <li>Use proprietary information, strategies, or materials for commercial purposes without written permission</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">Communications Consent</h2>
          <p className="text-gray-300">
            By providing your contact information (email address and phone number), you expressly consent to receive communications from Ability Healthcare Solutions via email and SMS text messages. These communications may include:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li>Appointment confirmations and calendar links</li>
            <li>Service updates and follow-up messages</li>
            <li>Educational content and resources</li>
            <li>Marketing materials and promotional offers</li>
            <li>Business announcements</li>
          </ul>
          <p className="text-gray-300">
            You may opt out of communications at any time by replying "STOP" to text messages or clicking unsubscribe in emails.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">User Obligations</h2>
          <p className="text-gray-300">
            When using our services, you agree to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of any account credentials</li>
            <li>Attend scheduled sessions on time and prepared</li>
            <li>Treat consultants and staff with respect and professionalism</li>
            <li>Not record, screenshot, or distribute session content without permission</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">Limitation of Liability</h2>
          <p className="text-gray-300">
            Ability Healthcare Solutions provides consulting services and educational information. While we strive to provide accurate and valuable guidance, we make no guarantees about specific business outcomes or results. You acknowledge that:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li>Business success depends on many factors outside our control</li>
            <li>Our advice should be adapted to your specific circumstances</li>
            <li>You are responsible for compliance with all applicable laws and regulations</li>
            <li>We are not liable for any financial losses resulting from business decisions</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8 mb-4">Termination of Services</h2>
          <p className="text-gray-300">
            Ability Healthcare Solutions reserves the right to refuse service or terminate access to services for clients who:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li>Violate these terms and conditions</li>
            <li>Engage in abusive, threatening, or inappropriate behavior</li>
            <li>Misrepresent information or engage in fraudulent activity</li>
            <li>Fail to honor payment obligations</li>
          </ul>
          <p className="text-gray-300">
            Termination does not entitle clients to refunds of any kind.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Third-Party Services</h2>
          <p className="text-gray-300">
            Our website and services integrate with third-party platforms including Calendly (scheduling), Stripe (payment processing), and Google (email services). Use of these services is subject to their respective terms and conditions and privacy policies.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Modifications to Terms</h2>
          <p className="text-gray-300">
            Ability Healthcare Solutions reserves the right to modify these terms and conditions at any time. Changes will be posted on our website with the effective date noted. Continued use of our services after changes constitutes acceptance of the modified terms.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Governing Law</h2>
          <p className="text-gray-300">
            These terms and conditions are governed by and construed in accordance with the laws of the United States, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4">Contact Information</h2>
          <p className="text-gray-300">
            If you have any questions about these Terms and Conditions, please contact us:
          </p>
          <p className="text-gray-300">
            📧 support@abilityhealthsolutions.com<br/>
            🌐 www.abilityhealthsolutions.com
          </p>

          <p className="text-sm text-gray-500 mt-8">
            Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <div className="bg-yellow-900/30 border-2 border-yellow-500 rounded-xl p-6 my-8">
            <p className="text-yellow-200 font-semibold">
              ⚠️ By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions, including our strict no-refund and no-reschedule policy.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 px-4 mt-12">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Ability Healthcare Solutions. All rights reserved.
          </p>
          <div className="mt-4 space-x-4">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm">Terms & Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
